export default __webpack_public_path__ + "static/media/SUBARU.08aa1ce4.png";